<!--耗金额统计-->
<template>
  <div  class="root-container">

   开发中


  </div>


</template>

<style scoped>

  .root-container{
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .search-content-area{
    width: 90%;
    /*设置边框颜色和圆角*/
    height: 200px;
    border-radius: 4px;
    border-top: 2px solid rgb(227,227,227);
    border-bottom: 1px solid rgb(227,227,227);
    border-left: 1px solid rgb(227,227,227);
    border-right: 1px solid rgb(227,227,227);
    /*border:1px solid rgb(227,227,227);*/
  }
  .class-input-search{
    margin-top: 20px;
    font-weight: 700;
  }
  .search-button-area{
    width: 90%;
    height: 50px;
    /*设置边框颜色和圆角*/
    border-radius: 4px;
    border-bottom: 2px solid rgb(227,227,227);
    border-left: 1px solid rgb(227,227,227);
    border-right: 1px solid rgb(227,227,227);
    /*border:1px solid rgb(227,227,227);*/
  }

  .search-result-area{
    width: 100%;
    margin-top: 50px;
    /*设置边框颜色和圆角*/
    border-top: 2px solid rgb(227,227,227);
    border-bottom: 1px solid rgb(227,227,227);
    border-left: 1px solid rgb(227,227,227);
    border-right: 1px solid rgb(227,227,227);
  }




  .bg-purple {
    background: #d3dce6;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .grid-content {
    border-radius: 4px;
    min-height: 36px;
    font-size: 20px;
  }


</style>

<script>


  export default {
    data() {
      return {




      }
    },
    created() {

    },
    methods: {

    }
  }
</script>






// WEBPACK FOOTER //
// src/views/market-analysis/ma-consume/indexBs.vue